import React, { useState } from 'react'
import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500',],subsets:['latin'],display:'swap',preload:true})

export default function NewCourseOverview({SectionRef,title,location1,img}) {
    const [showMore, setShowMore] = useState(1);


    const handleReadMore = () => {
        if (showMore < overview.length) {
            setShowMore(prev => prev + 1); // Show one more item
        }
    };
  return (
   <>
   <section className={`container`} ref={SectionRef}>
    <div className='whole-pdtb'>
   <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> <span className={`ylw-clr fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>  Comprehensive Overview of  </span>  {title} Training</h2> 

    <div className={`df fac fjc fjsb fw mfac mfjc tmt20 mmt16`}>
   
        <div  className={`w55p mw100p`}>
        {overview.slice(0, showMore).map((items,index)=>(
        // <p key={index} className={`fs-16 mfs-15 fwb400 mt8 ${quickSand.className}`} dangerouslySetInnerHTML={{ __html: items }}>{location1}</p>
        <>
        {items.heading && <h3 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>{items.heading}</h3> }
        <p key={index}
        className={`fs-16 mfs-15 fwb400 mt14 ${quickSand.className}`}
        dangerouslySetInnerHTML={{
            __html: items.para.replace(/in\${(.*?)}/g, function (match, p1) {
                return location1 || " " // Use fallback if location1 is undefined
            }),
        }}
    ></p>
     {
              items.Subheading &&
              items.Subheading.map((head,index)=>(
                <div key={index}>
                <h3 key={index} className={`fs-16 mfs-15 fw6 p-clr mt12 fwb cb`}>{head.Subtitle}</h3>
                <p key={index} className={`fs-16 mfs-15 fw6 p-clr `}>{head.Subpara}</p>
                </div>

          ))
        } 
    </>
      ))}
      {showMore < overview.length &&(
       <button
            className="btn-readmore mt10"
            onClick={handleReadMore}>
        {!showMore ? "Read Less" : "Read More"}
    </button>
    )}
        </div>
        
        <Image className='br20 mdn mt8' src={`/course/${img}.webp`} width={505} height={336} alt={`${title} ${location1 || "India"} Course Images`} loading='eager' quality={100}/>
        <Image className='br20 dn mdb mmt24' src={`/course/${img}.webp`} width={290} height={193}  alt={`${title} ${location1} Course Images`} 
         loading='eager' quality={100}/>

    </div>
    </div>
   </section>
   
   </>
  )
}
